export enum RecommendationType {

  STANDARD = 'STANDARD',
  FRIENDS_AND_FAMILY = 'FRIENDS_AND_FAMILY'

}
